import { css } from "styled-components";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
export const riotProductSkin = (chroma, paletteTokens) => css `
  padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};

  a {
    color: ${paletteTokens.bladetext1};
    text-decoration: underline;
    text-decoration-color: ${paletteTokens.accents1};

    &:hover {
      color: ${paletteTokens.accents1};
    }
  }

  .patch-change-block {
    .reference-link {
      float: left;
      margin-bottom: ${chroma.spacers.variable.m};
      width: 120px;
    }

    hr {
      clear: both;
    }

    blockquote {
      clear: both;
      padding-top: 0;
    }

    .context {
      font-size: 18px;
      font-weight: 400;
      line-height: 26px;
      text-align: left;
    }

    .summary {
      color: ${paletteTokens.bladetext1_light};
      padding-left: 144px;
      padding-top: ${chroma.spacers.variable.xs};
      font-size: 14px;
      line-height: 22px;
    }
  }

  .divider {
    margin: ${chroma.spacers.variable.m} 0;
    border: 0.5px solid ${paletteTokens.keyline};
    display: block;
  }

  ul {
    list-style-type: disc;
    padding-left: ${chroma.spacers.variable.m};
    line-height: 32px;
  }

  h2 {
    padding: ${chroma.spacers.variable.s} 0;
    font-size: 32px;
  }

  br {
    content: "";
    height: 10px;
    display: block;
  }

  #patch-top {
    margin: 0;
    padding: 0;
  }

  .default-2-col {
    ${chroma.mediaQueries.tabletUp} {
      padding-top: ${chroma.spacers.variable.m};
    }

    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .default-2-col > * {
    box-sizing: border-box;

    ${chroma.mediaQueries.tabletUp} {
      width: 50%;
    }
  }

  .context-designer {
    display: flex;
    align-items: center;
    ${chroma.typography.body5};
    color: ${paletteTokens.bladetext1_light};
    margin: ${chroma.spacers.variable.m} 0;
    ${textUppercaseMixin};

    img {
      height: 32px;
      width: 32px;
      border-radius: 50%;
      margin-right: ${chroma.spacers.variable.s};
    }
  }

  .change-detail-title {
    display: flex;
    align-items: center;
    font-weight: 550;
    font-size: 22px;
    line-height: 32px;
    margin-bottom: ${chroma.spacers.variable.m};

    img {
      margin-right: ${chroma.spacers.variable.sm};
    }
  }

  .skin-box {
    ${chroma.mediaQueries.tabletUp} {
      flex: 0 0 calc(50% - 16px);
    }

    ${chroma.mediaQueries.mobileOnly} {
      padding-top: ${chroma.spacers.variable.m};
    }

    a {
      img {
        margin-bottom: ${chroma.spacers.variable.s};
      }
    }
  }

  .change-title {
    ${chroma.typography.body1};
    color: ${paletteTokens.bladetext1};
    padding: ${chroma.spacers.variable.xs} 0 0 144px;
    margin-top: 0;

    a {
      ${chroma.typography.body1};
      font-weight: 550;
      text-decoration: none;
    }
  }

  #patch-notes-container {
    padding: ${chroma.spacers.variable.m};

    ul {
      margin-top: ${chroma.spacers.variable.s};
    }

    p {
      margin-top: ${chroma.spacers.variable.s};
    }

    .summary {
      margin-top: 0;
    }

    div.content-border {
      padding: ${chroma.spacers.variable.m};
      margin: 0 calc(${chroma.spacers.variable.m} * -1) ${chroma.spacers.variable.m};
      border: solid 1px ${paletteTokens.keyline};
      font-size: 18px;
      line-height: 26px;

      blockquote {
        padding-left: 0;
        padding-right: 0;
      }
    }

    .skin-box {
      img {
        margin-bottom: ${chroma.spacers.variable.s};
      }

      .skin-title {
        display: inline;
      }
    }
  }

  .blockquote {
    ${chroma.typography.body3};
    color: ${paletteTokens.bladetext1};
    font-weight: normal;
    text-align: left;
    font-style: normal;

    &::before,
    &::after {
      color: ${paletteTokens.bladetext1_light};
      ${chroma.typography.body1}
      display: inline-block;
    }

    /* note: line-height in a separate rule from responsive typography to prevent it from being overridden at different breakpoints */

    &::before {
      content: open-quote;
      margin-right: 5px;
      line-height: 0;
    }

    &::after {
      content: close-quote;
      margin-left: 5px;
      line-height: 0;
    }
  }

  .header-primary {
    ${chroma.typography.display6}
    color: ${paletteTokens.bladetext1};
    font-style: italic;
  }
`;
//# sourceMappingURL=index.js.map